import { Exception } from 'src/app/core/logic/exception';

export class PatientSerieItemNotFoundException extends Exception<never> {
  constructor() {
    super('Élément de série non trouvé');
  }
}
